import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import useGetSeriesList from 'entity/series/useGetSeriesList'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TableLoading from 'shared/ui/TableLoading'
import TicketUsageOverview from '../TicketUsageOverview'

const SeriesList = () => {
	const navigate = useNavigate()

	const [seriesList, isLoading] = useGetSeriesList()

	const btnList = [
		{
			label: '배치별 시드 티켓 발급',
			clickEvent: () => navigate(`/series/seed-template`),
		},
		{
			label: '생성',
			clickEvent: () => navigate('/series/create'),
			deactive: false,
		},
	]

	const sizeList = ['short', 'expand', 'medium', 'medium', 'long']
	const tableHeadList = [
		'IDX',
		'대회 시리즈 이름',
		'시작 날짜',
		'종료 날짜',
		'생성 날짜',
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList}>대회 시리즈 목록</MainHeader>
			<TicketUsageOverview />
			<Search placeholder='대회 시리즈 이름에 포함되는 글자로 검색' />
			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{seriesList?.data?.series_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => navigate(`/series/${elem?.idx}/detail`)}
							>
								<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>
									{timestampCalculator(elem?.start_date, 'date')}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>
									{timestampCalculator(elem?.end_date, 'date')}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={seriesList?.data?.max_page} />
		</Style.Wrapper>
	)
}

export default SeriesList
